/* Deen Health universal cart.
 * Based on the approved V210 reference. Native Shopify Ajax cart: Shopify owns the basket,
 * this file only reads it, changes individual lines and renders the drawer.
 * Configuration (products, plans, copy) comes from sections/deen-cart.liquid.
 */
(function () {
  'use strict';
  if (window.DeenCart) return;
  const node = document.getElementById('deen-cart-config');
  if (!node) return;
  const cfg = JSON.parse(node.textContent);
  const copy = cfg.copy || {};

  const route = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const rootURL = route.endsWith('/') ? route : route + '/';
  const by = (a, b) => String(a) === String(b);
  const esc = v => String(v == null ? '' : v).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const clone = x => JSON.parse(JSON.stringify(x));
  const uuid = () => (window.crypto && crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2));
  const fill = (text, vars) => String(text || '').replace(/\{(\w+)\}/g, (m, k) => (k in vars ? vars[k] : m));
  const num = (v, min = 1, max = 999) => {
    const n = Number(v);
    if (!Number.isInteger(n) || n < min || n > max) throw Error('Please choose a whole-number quantity between ' + min + ' and ' + max + '.');
    return n;
  };
  const storage = {
    get(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (_) { return null; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (_) {} }
  };

  // Catalogue: collagen plus the recommendation blocks, in merchant-defined order.
  const collagenProduct = cfg.collagen;
  const recommendations = (cfg.products || []).filter(p => p.available);
  const catalogue = [collagenProduct, ...(cfg.products || [])].filter(Boolean);
  const tierFrequency = { '30': '1-month', '90': '3-month', '180': '6-month' };
  const tierPlans = {};
  if (collagenProduct) {
    Object.keys(tierFrequency).forEach(t => {
      const plan = collagenProduct.plans.find(p => p.frequency === tierFrequency[t]);
      if (plan) tierPlans[t] = plan;
    });
  }

  let cart = { token: '', currency: cfg.currency, items: [], item_count: 0, total_price: 0 };
  let busy = false, open = false, editKey = '', error = '', notice = '', stale = true, handled = false, ready;
  let previousFocus, previousOverflow, backgroundNodes = [];

  const el = document.createElement('div');
  el.id = 'dc-root';
  el.hidden = true;
  el.innerHTML = '<button class="dc-shade" type="button" data-action="close" tabindex="-1" aria-label="Close cart"></button><section class="dc-panel" role="dialog" aria-modal="true" aria-labelledby="dc-title" tabindex="-1"><header class="dc-head"><div><span class="dc-kicker">DEEN HEALTH</span><h2 id="dc-title">Your cart <span id="dc-count"></span></h2></div><button class="dc-close" type="button" data-action="close" aria-label="Close cart">×</button></header><div class="dc-notice" role="status" aria-live="polite"></div><div class="dc-body"></div><footer class="dc-foot"></footer></section>';
  document.body.appendChild(el);
  const body = el.querySelector('.dc-body'), foot = el.querySelector('.dc-foot'), status = el.querySelector('.dc-notice');

  /* ---------- Line helpers ---------- */
  const planID = item => (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id) || null;
  const product = key => recommendations.find(p => p.key === key) || (collagenProduct && collagenProduct.key === key ? collagenProduct : null);
  const isCollagen = item => !!collagenProduct && by(item.product_id, collagenProduct.id);
  // Only the configured collagen variant takes part in the set/supply journey.
  const managed = item => isCollagen(item) && by(item.variant_id, collagenProduct.variantId);
  // Config entry for a line, with that line's own variant price and plans (plans belong to variants).
  // Collagen is only managed on its configured variant; other products on any variant, so a
  // Kaching bundle added on its product page can still switch between one-time and subscription.
  function forItem(item) {
    const exact = catalogue.find(p => by(p.id, item.product_id) && by(p.variantId, item.variant_id));
    if (exact) return exact;
    const p = catalogue.find(x => by(x.id, item.product_id));
    if (!p || p.key === 'collagen') return undefined;
    const v = (p.variants || []).find(x => by(x.id, item.variant_id));
    return v ? { ...p, variantId: v.id, price: v.price, available: v.available, plans: v.plans } : undefined;
  }
  const phase = () => (cart.items.some(isCollagen) ? 'collagen' : 'simple');
  const base = tier => (tier === '180' ? 6 : tier === '90' ? 3 : 1);
  function hcpTier(item) {
    if (!managed(item)) return null;
    const sp = planID(item);
    if (!sp) return 'one-time';
    return Object.keys(tierPlans).find(t => by(tierPlans[t].id, sp)) || null;
  }
  // Collagen card entry options. With the 90-day option, quantity counts routines: 1 = 3 pouches every 3 months.
  const collagenCardTiers = cfg.collagenCard90 === false ? ['30'] : ['30', '90'];
  const unitsPer = (p, planId) => (p && p.key === 'collagen' && tierPlans['90'] && by(planId, tierPlans['90'].id) ? base('90') : 1);
  const tierPrice = tier => (tier === 'one-time' ? collagenProduct.price : tierPlans[tier] && tierPlans[tier].price);

  function billing(freq) {
    const m = /^(\d+)-(day|week|month|year)s?$/.exec(freq || '');
    return m ? 'every ' + (m[1] === '1' ? m[2] : m[1] + ' ' + m[2] + 's') : freq;
  }
  function money(cents) {
    const opts = { style: 'currency', currency: cart.currency || cfg.currency, minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 };
    try { return new Intl.NumberFormat(cfg.locale || undefined, { ...opts, currencyDisplay: 'narrowSymbol' }).format(cents / 100); }
    catch (_) { return new Intl.NumberFormat(undefined, opts).format(cents / 100); }
  }

  /* ---------- Offer decision (per cart) ---------- */
  const decisionKey = () => 'deen-cart-decision-' + cart.token;
  function loadDecision() { handled = !!storage.get(decisionKey()); }
  function decision(value) { handled = value; storage.set(decisionKey(), value); }

  /* ---------- Shopify cart I/O ---------- */
  async function request(path, payload) {
    // Requests go through window.fetch on purpose: apps such as Kaching Bundles wrap it to merge
    // their bundle lines into cart/add. The header lets our own observer ignore them.
    const r = await fetch(rootURL + path, {
      method: payload ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Deen-Cart': '1', ...(payload ? { 'Content-Type': 'application/json' } : {}) },
      ...(payload ? { body: JSON.stringify(payload) } : {}),
      cache: 'no-store'
    });
    let data;
    try { data = await r.json(); } catch (_) { throw Error('The store could not be reached. Please try again.'); }
    if (!r.ok) throw Error(data.description || data.message || 'Your cart could not be updated. Please try again.');
    return data;
  }
  async function refresh() {
    const fresh = await request('cart.js');
    if (!Array.isArray(fresh.items) || !fresh.currency) throw Error('Cart information is unavailable. Please refresh and try again.');
    cart = fresh;
    stale = false;
    loadDecision();
    if (!cart.items.some(managed)) decision(false);
    publish();
    return cart;
  }
  function publish() {
    document.querySelectorAll('[data-deen-cart-count],[data-header-cart-count]').forEach(n => {
      if (el.contains(n)) return;
      n.textContent = cart.item_count;
      if (n.hasAttribute('data-hide-when-empty')) n.hidden = !cart.item_count;
    });
    document.querySelectorAll('[data-header-cart-total]').forEach(n => (n.textContent = money(cart.total_price)));
    window.dispatchEvent(new CustomEvent('deen:cart-updated', { detail: { cart: clone(cart), mode: phase() } }));
  }
  function checkedPlan(p, id) {
    if (!id) {
      if (p.requiresPlan) throw Error('Please choose an available subscription.');
      return null;
    }
    const plan = p.plans.find(x => by(x.id, id));
    if (!plan) throw Error('That subscription is no longer available. Please choose another option.');
    return plan;
  }
  async function changeLine(key, quantity, sellingPlan, properties) {
    // Refresh immediately before resolving an index: Shopify requires `line` for selling_plan changes.
    await refresh();
    const line = cart.items.findIndex(i => i.key === key);
    if (line < 0) throw Error('This item changed in your cart. Please check the updated cart and try again.');
    const item = cart.items[line];
    num(quantity, 0);
    const payload = { line: line + 1, quantity };
    if (sellingPlan !== undefined) payload.selling_plan = sellingPlan || null;
    if (properties) payload.properties = { ...(item.properties || {}), ...properties };
    await request('cart/change.js', payload);
    await refresh();
  }
  async function addLine(p, qty, plan, properties = {}) {
    num(qty);
    if (!p || !p.available) throw Error('This product is currently unavailable.');
    const sp = checkedPlan(p, plan);
    await request('cart/add.js', { items: [{ id: p.variantId, quantity: qty, ...(sp ? { selling_plan: sp.id } : {}), properties }] });
    await refresh();
  }
  async function transact(work, message) {
    if (busy) return false;
    busy = true; error = ''; notice = 'Updating your cart…';
    render();
    try {
      await ready;
      await refresh();
      await work();
      stale = false;
      notice = message || 'Your cart is updated.';
      return true;
    } catch (e) {
      error = e.message || 'Something went wrong. Please try again.';
      notice = '';
      try { await refresh(); } catch (_) { stale = true; }
      return false;
    } finally {
      busy = false; editKey = '';
      render();
    }
  }

  /* ---------- Rendering ---------- */
  const disabled = () => (busy ? ' disabled' : '');
  function image(p, cls = '') {
    if (p.placeholderColor) return '<span class="dc-photo ' + cls + '"><span class="dc-color-box" role="img" aria-label="' + esc(p.title) + ' placeholder" style="background:' + esc(p.placeholderColor) + ';color:' + esc(p.placeholderTextColor) + '"><span class="dc-mini-brand">DEEN</span><span class="dc-mini-rule"></span><span class="dc-mini-label">' + esc(p.label || p.title) + '</span></span></span>';
    return '<span class="dc-photo ' + cls + '">' + (p.image ? '<img loading="lazy" src="' + esc(p.image) + '" alt="' + esc(p.title) + '">' : '<span class="dc-placeholder">DEEN HEALTH<br>' + esc(p.label || p.title) + '</span>') + '</span>';
  }
  const productLink = (p, content, cls = '') => (p.url ? '<a class="' + cls + '" href="' + esc(p.url) + '">' + content + '</a>' : '<span class="' + cls + '">' + content + '</span>');

  function billingText(item) {
    const p = forItem(item), sp = planID(item), plan = p && p.plans.find(x => by(x.id, sp));
    if (!sp) return 'One-time purchase';
    // Amount from the cart line itself, so bundle discounts are reflected.
    return (plan ? money(item.final_line_price) + ' ' + billing(plan.frequency) : esc(item.selling_plan_allocation.selling_plan.name)) + ' · Cancel anytime';
  }
  function itemHTML(item) {
    const p = forItem(item) || { title: item.product_title || item.title, image: item.image, url: item.url, label: 'DEEN HEALTH' };
    const tier = hcpTier(item), props = item.properties || {}, people = Number(props._dh_people) || 0;
    const unit = isCollagen(item) ? (item.quantity === 1 ? 'pouch' : 'pouches') : item.quantity === 1 ? 'unit' : 'units';
    const set = people && tier ? ({ 1: 'Single Set', 2: 'Duo Set', 3: 'Family Set' }[people] || people + ' people') + ' · ' : '';
    const supply = tier ? (tier === 'one-time' ? '30-day supply' : tier + '-day supply') + ' · ' : '';
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? esc(item.variant_title) + ' · ' : '';
    const custom = Object.entries(props).filter(([k, v]) => k[0] !== '_' && v).map(([k, v]) => '<div class="dc-meta">' + esc(k) + ': ' + esc(v) + '</div>').join('');
    // The managed collagen line is changed through its editor/offer, never a generic −/+ box.
    const qty = managed(item) ? '' : '<div class="dc-qty"><button data-action="decrease" aria-label="Decrease quantity of ' + esc(p.title) + '"' + disabled() + '>−</button><output aria-label="Quantity">' + item.quantity + '</output><button data-action="increase" aria-label="Increase quantity of ' + esc(p.title) + '"' + disabled() + '>+</button></div>';
    const price = (item.original_line_price > item.final_line_price ? '<s>' + money(item.original_line_price) + '</s>' : '') + money(item.final_line_price);
    return '<article class="dc-item" data-key="' + esc(item.key) + '"><div class="dc-item-main">' + productLink(p, image(p)) + '<div>' + productLink(p, esc(p.title), 'dc-item-name') + '<div class="dc-meta">' + set + (people ? supply : variant) + item.quantity + ' ' + unit + '</div>' + custom + '<div class="dc-billing">' + billingText(item) + '</div></div><div class="dc-line-price">' + price + '</div></div><div class="dc-item-actions">' + qty + '<div class="dc-actions-right">' + (forItem(item) ? '<button class="dc-link" data-action="edit"' + disabled() + '>Edit</button>' : '') + '<button class="dc-link dc-link-muted" data-action="remove"' + disabled() + '>Remove</button></div></div>' + (editKey === item.key ? editHTML(item) : '') + '</article>';
  }
  function planOptions(p, selected, initial = false) {
    let plans = p.plans;
    // Collagen entry from the cart: one-time, monthly and (if enabled) the 90-day routine; 180 days comes through the offer.
    if (p.key === 'collagen' && initial) plans = plans.filter(s => collagenCardTiers.some(t => tierPlans[t] && by(s.id, tierPlans[t].id)));
    const label = s => 'Subscribe ' + billing(s.frequency) + (initial && unitsPer(p, s.id) > 1 ? ' · ' + unitsPer(p, s.id) + ' pouches' : '');
    return (!p.requiresPlan ? '<option value=""' + (!selected ? ' selected' : '') + '>One-time purchase</option>' : '') + plans.map(s => '<option value="' + esc(s.id) + '"' + (by(s.id, selected) ? ' selected' : '') + '>' + esc(label(s)) + '</option>').join('');
  }
  function quantityControl(context, quantity, p) {
    const title = esc(p.title), value = num(quantity);
    return '<div class="dc-quantity-field"><span class="dc-quantity-label">' + (context === 'edit' ? 'Units per delivery' : 'Quantity') + '</span><div class="dc-qty dc-choice-qty" role="group" aria-label="Quantity for ' + title + '"><button type="button" data-action="quantity-step" data-step="-1" aria-label="Decrease quantity of ' + title + '"' + (busy || value <= 1 ? ' disabled' : '') + '>−</button><output data-' + context + '-qty aria-label="Quantity" aria-live="polite">' + value + '</output><button type="button" data-action="quantity-step" data-step="1" aria-label="Increase quantity of ' + title + '"' + (busy || value >= 999 ? ' disabled' : '') + '>+</button></div></div>';
  }
  function editHTML(item) {
    const p = forItem(item), props = item.properties || {}, tier = hcpTier(item), withSet = managed(item) && props._dh_people && tier;
    const planSelect = '<label>Purchase option<select data-edit-plan>' + planOptions(p, planID(item)) + '</select></label>';
    const setSelect = '<label>Set<select data-edit-people>' + [[1, 'Single Set'], [2, 'Duo Set'], [3, 'Family Set']].map(([v, t]) => '<option value="' + v + '"' + (Number(props._dh_people) === v ? ' selected' : '') + '>' + t + '</option>').join('') + '</select></label>';
    const amount = withSet ? setSelect : managed(item) ? '<label>Units per delivery<input type="number" min="1" max="999" value="' + item.quantity + '" data-edit-qty></label>' : quantityControl('edit', item.quantity, p);
    return '<div class="dc-edit"><div class="dc-fields">' + planSelect + amount + '</div><div class="dc-edit-total" data-edit-total></div><div class="dc-edit-footer"><button class="dc-button dc-button-small" data-action="save"' + disabled() + '>Save changes</button><button class="dc-link" data-action="cancel-edit">Cancel</button></div></div>';
  }

  function offer() {
    if (handled || !collagenProduct || !collagenProduct.available) return null;
    const i = cart.items.find(i => managed(i) && hcpTier(i));
    if (!i) return null;
    const tier = hcpTier(i), next = { 'one-time': '30', '30': '90', '90': '180' }[tier], sp = tierPlans[next];
    if (!next || !sp) return null;
    const factor = i.quantity / base(tier);
    if (!Number.isInteger(factor) || factor < 1) return null;
    // Compare catalogue prices, so a discount code on the line does not distort the pitch.
    const oldPrice = tierPrice(tier), qty = base(next) * factor, total = qty * sp.price;
    if (!oldPrice || oldPrice * qty - total <= 0) return null;
    const people = Number((i.properties || {})._dh_people) || 0;
    const vars = {
      saving: money(oldPrice - sp.price), percent: Math.round(((oldPrice - sp.price) / oldPrice) * 100),
      old_price: money(oldPrice), new_price: money(sp.price), qty, total: money(total), days: next, current_days: tier
    };
    const ship = ['90', '180'].includes(next) && (cfg.freeShippingCountries || []).includes(cfg.country) && copy.freeShipping ? ' ' + copy.freeShipping : '';
    if (tier === 'one-time') {
      return {
        item: i, next, plan: sp, qty, total, isOneTime: true,
        kicker: fill(copy.monthlyKicker, vars),
        title: fill(people === 2 ? copy.monthlyTitleDuo : people === 3 ? copy.monthlyTitleFamily : copy.monthlyTitle, vars),
        copy: fill(people > 1 ? copy.monthlyCopyGroup : copy.monthlyCopy, vars),
        cta: fill(copy.monthlyCta, vars), decline: fill(copy.monthlyDecline, vars)
      };
    }
    return {
      item: i, next, plan: sp, qty, total, isOneTime: false,
      kicker: fill(copy.upgradeKicker, vars), title: fill(copy.upgradeTitle, vars), copy: fill(copy.upgradeCopy, vars) + ship,
      cta: fill(copy.upgradeCta, vars), decline: fill(copy.upgradeDecline, vars)
    };
  }
  function offerHTML(o) {
    const review = o.isOneTime && cfg.azizaReviewImage ? '<figure class="dc-aziza-review"><img src="' + esc(cfg.azizaReviewImage) + '" alt="Customer review from Aziza about her joint pain returning after she ran out of collagen"><figcaption>' + esc(copy.azizaCaption) + '</figcaption></figure>' : '';
    const comparison = o.isOneTime ? '<div class="dc-onetime-compare"><div><span>YOUR CART</span><strong>' + money(o.item.final_line_price) + '</strong><small>One-time purchase</small></div><span aria-hidden="true">→</span><div><span>AUTOMATIC DELIVERY</span><strong>' + money(o.total) + '</strong><small>Every month</small></div></div>' : '';
    return '<section class="dc-offer"><span class="dc-kicker">' + esc(o.kicker) + '</span><h3>' + esc(o.title) + '</h3><p>' + esc(o.copy) + '</p>' + review + comparison + '<p class="dc-offer-bill">Billed ' + money(o.total) + ' ' + billing(o.plan.frequency) + '. Cancel anytime.</p><button class="dc-button" data-action="upgrade"' + disabled() + '>' + esc(o.cta) + '</button><button class="dc-link" data-action="decline"' + disabled() + '>' + esc(o.decline) + '</button></section>';
  }
  function recHTML(p) {
    const preset = p.defaultPlan && p.plans.find(s => s.frequency === p.defaultPlan);
    return '<article class="dc-rec" data-product="' + esc(p.key) + '"><div class="dc-rec-main">' + productLink(p, image(p)) + '<div>' + productLink(p, esc(p.title), 'dc-item-name') + '<div class="dc-benefit">' + esc(p.benefit) + '</div>' + productLink(p, 'View product', 'dc-link') + '</div></div><div class="dc-fields"><label>Purchase option<select data-rec-plan>' + planOptions(p, preset ? preset.id : null, true) + '</select></label>' + quantityControl('rec', 1, p) + '</div><div class="dc-rec-price" data-rec-price></div><button class="dc-button dc-secondary" data-action="add-rec"' + disabled() + '>Add to cart</button></article>';
  }
  function recsHTML() {
    // Exclude at product level, even if a different variant or purchase type is in the cart.
    const shown = recommendations.filter(p => !cart.items.some(i => by(i.product_id, p.id)));
    if (!shown.length) return '';
    return '<section class="dc-recs"><h3>' + esc(cart.items.length ? copy.recsHeading : copy.recsHeadingEmpty) + '</h3><p class="dc-recs-intro">' + esc(copy.recsIntro) + '</p>' + shown.map(recHTML).join('') + '</section>';
  }
  function render() {
    el.dataset.mode = phase();
    el.querySelector('#dc-count').textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    status.textContent = error || notice;
    status.classList.toggle('dc-error', !!error);
    status.setAttribute('role', error ? 'alert' : 'status');
    const o = offer();
    body.innerHTML = (cart.items.length ? '<div class="dc-mode">Your essentials, your way.</div>' + cart.items.map(itemHTML).join('') : '<div class="dc-empty"><h3>' + esc(copy.emptyTitle) + '</h3><p>' + esc(copy.emptyText) + '</p></div>') + (o ? offerHTML(o) : recsHTML());
    foot.innerHTML = '<div class="dc-subtotal"><span>Subtotal</span><span>' + money(cart.total_price) + '<span class="dc-currency">' + esc(cart.currency) + '</span></span></div><button class="dc-button dc-checkout" data-action="checkout"' + (busy || !cart.item_count || stale ? ' disabled' : '') + '>' + (busy ? 'Updating your cart…' : 'CONTINUE TO CHECKOUT →') + '</button>' + (stale && !busy ? '<button class="dc-link" data-action="refresh">Refresh cart</button>' : '');
    el.querySelectorAll('[data-rec-price]').forEach(updateRecPrice);
    el.querySelectorAll('[data-edit-total]').forEach(updateEditPrice);
    if (open && !el.contains(document.activeElement)) focusFirst();
  }
  function updateRecPrice(n) {
    const card = n.closest('[data-product]'), p = product(card.dataset.product), s = card.querySelector('[data-rec-plan]').value;
    const plan = p.plans.find(x => by(x.id, s)), q = Number(card.querySelector('[data-rec-qty]').value) || 1, units = unitsPer(p, s) * q;
    n.innerHTML = money((plan ? plan.price : p.price) * units) + ' <small>' + (units !== q ? units + ' pouches · ' : '') + (plan ? esc(billing(plan.frequency)) : 'One-time purchase') + '</small>';
  }
  function editValues(row, item) {
    const p = forItem(item), id = row.querySelector('[data-edit-plan]').value || null, sp = checkedPlan(p, id), props = { ...(item.properties || {}) };
    let q;
    if (row.querySelector('[data-edit-people]')) {
      const people = num(row.querySelector('[data-edit-people]').value, 1, 3);
      const tier = id ? Object.keys(tierPlans).find(t => by(tierPlans[t].id, id)) : 'one-time';
      if (!tier) throw Error('Choose a supported collagen delivery option.');
      q = base(tier) * people;
      props._dh_people = String(people);
      props._dh_plan = tier;
    } else if (row.querySelector('input[data-edit-qty]')) {
      q = num(row.querySelector('input[data-edit-qty]').value);
      props._dh_people = '';
    } else {
      q = num(row.querySelector('output[data-edit-qty]').value);
    }
    return { qty: q, id, sp, props };
  }
  function updateEditPrice(n) {
    try {
      const row = n.closest('[data-key]'), item = cart.items.find(i => i.key === row.dataset.key), v = editValues(row, item), p = forItem(item);
      n.textContent = v.qty + ' ' + (isCollagen(item) ? 'pouches' : 'units') + ' · ' + money((v.sp ? v.sp.price : p.price) * v.qty) + (v.sp ? ' ' + billing(v.sp.frequency) + ' · Cancel anytime' : ' · One-time purchase');
    } catch (e) { n.textContent = e.message; }
  }

  /* ---------- Drawer ---------- */
  function focusFirst() { el.querySelector('.dc-close').focus(); }
  function show(refreshCart = true) {
    if (!open) {
      previousFocus = document.activeElement;
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      backgroundNodes = [...document.body.children].filter(n => n !== el && !n.inert && n.tagName !== 'SCRIPT' && n.tagName !== 'STYLE');
      backgroundNodes.forEach(n => (n.inert = true));
      el.hidden = false;
      open = true;
      render();
      focusFirst();
    }
    if (refreshCart && !busy) transact(async () => {}, '');
  }
  function close() {
    if (!open) return;
    el.hidden = true;
    open = false;
    document.body.style.overflow = previousOverflow || '';
    backgroundNodes.forEach(n => (n.inert = false));
    backgroundNodes = [];
    if (previousFocus && previousFocus.isConnected) previousFocus.focus();
  }

  /* ---------- Public actions ---------- */
  async function addProduct(key, qty = 1, plan = null) {
    show(false);
    return transact(async () => {
      const p = product(key), isHcp = !!p && p.key === 'collagen';
      const tier = !plan ? 'one-time' : Object.keys(tierPlans).find(t => by(tierPlans[t].id, plan));
      await addLine(p, num(qty) * unitsPer(p, plan), plan, isHcp ? { _dh_routine: uuid(), _dh_source: 'recommendation', ...(tier ? { _dh_plan: tier } : {}) } : {});
      if (isHcp) decision(false);
    }, 'Added to your cart.');
  }
  async function addCollagen(tier = '90', people = 1) {
    show(false);
    return transact(async () => {
      const p = collagenProduct;
      if (!p) throw Error('Collagen is unavailable. Please try again.');
      num(people, 1, 3);
      if (!['one-time', '30', '90', '180'].includes(tier)) throw Error('Choose a valid collagen plan.');
      const sp = tier === 'one-time' ? null : tierPlans[tier];
      if (tier !== 'one-time' && !sp) throw Error('This collagen subscription is unavailable. Please choose another supply.');
      const existing = cart.items.find(i => managed(i) && (i.properties || {})._dh_source === 'pdp');
      const props = { _dh_routine: (existing && existing.properties._dh_routine) || uuid(), _dh_source: 'pdp', _dh_people: String(people), _dh_plan: tier };
      if (existing) await changeLine(existing.key, base(tier) * people, sp ? sp.id : null, props);
      else await addLine(p, base(tier) * people, sp ? sp.id : null, props);
      decision(false);
    }, 'Your collagen routine is in the cart.');
  }
  async function checkout() {
    if (busy) return;
    const ok = await transact(async () => { if (!cart.items.length) throw Error('Your cart is empty.'); }, '');
    if (!ok) return;
    busy = true;
    notice = 'Taking you to checkout…';
    render();
    location.assign(rootURL + 'checkout');
  }

  /* ---------- Events ---------- */
  function onFieldChange(e) {
    const r = e.target.closest('[data-product]');
    if (r) updateRecPrice(r.querySelector('[data-rec-price]'));
    const row = e.target.closest('[data-key]');
    if (row && row.querySelector('[data-edit-total]')) updateEditPrice(row.querySelector('[data-edit-total]'));
  }
  el.addEventListener('input', onFieldChange);
  el.addEventListener('change', onFieldChange);
  el.addEventListener('click', e => {
    const button = e.target.closest('[data-action]');
    if (!button) return;
    const action = button.dataset.action;
    e.preventDefault();
    if (action === 'close') { close(); return; }
    if (busy) return;
    if (action === 'quantity-step') {
      const group = button.closest('.dc-choice-qty'), output = group.querySelector('output');
      const next = Math.max(1, Math.min(999, Number(output.value) + Number(button.dataset.step)));
      output.value = String(next);
      group.querySelector('[data-step="-1"]').disabled = next <= 1;
      group.querySelector('[data-step="1"]').disabled = next >= 999;
      const rec = group.closest('[data-product]'), edit = group.closest('.dc-edit');
      if (rec) updateRecPrice(rec.querySelector('[data-rec-price]'));
      if (edit) updateEditPrice(edit.querySelector('[data-edit-total]'));
      return;
    }
    const row = button.closest('[data-key]'), item = row && cart.items.find(i => i.key === row.dataset.key);
    if (action === 'checkout') { checkout(); return; }
    if (action === 'refresh') { transact(async () => {}, 'Your cart is up to date.'); return; }
    if (action === 'edit') { editKey = editKey === item.key ? '' : item.key; render(); const f = body.querySelector('[data-edit-plan]'); if (f) f.focus(); return; }
    if (action === 'cancel-edit') { editKey = ''; render(); return; }
    if (action === 'decline') {
      decision(true);
      notice = 'Your selection stays just as it is.';
      render();
      const h = body.querySelector('.dc-recs');
      if (h) h.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      return;
    }
    if (action === 'add-rec') {
      const rec = button.closest('[data-product]');
      addProduct(rec.dataset.product, rec.querySelector('[data-rec-qty]').value, rec.querySelector('[data-rec-plan]').value || null);
      return;
    }
    if (action === 'upgrade') {
      const o = offer();
      if (!o) return;
      transact(async () => {
        await changeLine(o.item.key, o.qty, o.plan.id, { _dh_routine: (o.item.properties || {})._dh_routine || uuid(), _dh_plan: o.next });
        decision(true);
        window.dispatchEvent(new CustomEvent('deen:collagen-selected', { detail: { tier: o.next, people: Number((o.item.properties || {})._dh_people) || null } }));
      }, copy.upgradeSuccess);
      return;
    }
    if (!item) return;
    if (action === 'save') {
      let v;
      try { v = editValues(row, item); } catch (err) { error = err.message; render(); return; }
      transact(async () => {
        await changeLine(item.key, v.qty, v.id, v.props);
        if (managed(item)) {
          decision(true);
          const tier = v.id ? Object.keys(tierPlans).find(t => by(tierPlans[t].id, v.id)) : 'one-time';
          window.dispatchEvent(new CustomEvent('deen:collagen-selected', { detail: { tier, people: Number(v.props._dh_people) || null } }));
        }
      }, 'Your changes are saved.');
      return;
    }
    const quantity = action === 'remove' ? 0 : action === 'increase' ? item.quantity + 1 : item.quantity - 1;
    transact(async () => {
      await changeLine(item.key, Math.max(0, quantity), undefined);
      if (!cart.items.some(managed)) decision(false);
    }, quantity > 0 ? 'Quantity updated.' : 'Removed from your cart.');
  });
  document.addEventListener('keydown', e => {
    if (!open) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'Tab') {
      const focusable = [...el.querySelectorAll('button:not(:disabled),a[href],select:not(:disabled),input:not(:disabled),[tabindex="0"]')].filter(n => n.tabIndex >= 0 && n.getClientRects().length);
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (!first) { e.preventDefault(); el.querySelector('.dc-panel').focus(); return; }
      if (e.shiftKey && (document.activeElement === first || !el.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !el.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    }
  });
  // Header cart icons (Local's sidebar handles and plain /cart links) open this drawer instead.
  // Capture phase runs before the theme's own handlers, which never see the click.
  // On the cart page itself the links keep their normal behaviour.
  const cartLinkSelector = '[data-deen-cart-open]' + (cfg.interceptCartLinks && !cfg.isCartPage ? ',[aria-controls="site-cart-sidebar"],a[href="/cart"],a[href="' + rootURL + 'cart"]' : '');
  document.addEventListener('click', e => {
    const link = e.target.closest(cartLinkSelector);
    if (link && !el.contains(link)) { e.preventDefault(); e.stopImmediatePropagation(); show(); }
  }, true);
  // Local opens its sidebar on keyup, so keyboard activation is intercepted there too.
  document.addEventListener('keyup', e => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const link = e.target.closest && e.target.closest(cartLinkSelector);
    if (link && !el.contains(link) && link.getAttribute('role') === 'button') { e.preventDefault(); e.stopImmediatePropagation(); show(); }
  }, true);
  // Every add-to-cart form (product pages, quick buy, quick view, sticky bars) adds through this cart.
  // Capture phase: runs before the theme's ProductForm and Kaching's form fallback. Line properties —
  // including Kaching's bundle tag and Recharge's selling_plan input — are passed through unchanged.
  document.addEventListener('submit', e => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || el.contains(form)) return;
    if (!form.matches('[data-deen-cart-form]') && !(cfg.interceptForms && new URL(form.action, location.href).pathname.endsWith('/cart/add'))) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (busy) return;
    const data = new FormData(form, e.submitter || undefined);
    const modal = form.closest('modal-box');
    if (modal && typeof modal.hide === 'function') modal.hide();
    // Local mirrors this class onto its sticky add-to-cart bar, so set and clear it like the theme does.
    const button = e.submitter || form.querySelector('[type="submit"]');
    if (button) button.classList.add('working');
    show(false);
    transact(async () => {
      const id = data.get('id'), q = num(data.get('quantity') || 1), sp = data.get('selling_plan') || null;
      if (!/^\d+$/.test(String(id))) throw Error('Choose a product option first.');
      const props = {};
      for (const [k, v] of data) { const m = /^properties\[(.+)\]$/.exec(k); if (m && v !== '') props[m[1]] = v; }
      await request('cart/add.js', { items: [{ id: Number(id), quantity: q, ...(sp ? { selling_plan: Number(sp) } : {}), properties: props }] });
      await refresh();
      if (collagenProduct && by(id, collagenProduct.variantId)) decision(false);
    }, 'Added to your cart.').finally(() => { if (button) button.classList.remove('working'); });
  }, true);
  // Returning from checkout or via the back button can restore a cached page: re-read the cart.
  window.addEventListener('pageshow', e => {
    busy = false;
    if (open) transact(async () => {}, '');
    else if (e.persisted) refresh().then(render).catch(() => {});
  });

  // Keep in sync when something else changes the cart (apps, legacy page code).
  let syncTimer;
  const pageFetch = window.fetch;
  window.fetch = function (input, init) {
    const result = pageFetch.apply(this, arguments);
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const headers = (init && init.headers) || {};
    const ours = headers instanceof Headers ? headers.has('X-Deen-Cart') : !!headers['X-Deen-Cart'];
    if (!ours && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      result.then(r => {
        if (!r.ok) return;
        clearTimeout(syncTimer);
        syncTimer = setTimeout(() => { if (!busy) refresh().then(render).catch(() => {}); }, 150);
      }, () => {});
    }
    return result;
  };

  window.DeenCart = {
    open: () => show(),
    close,
    addProduct,
    addCollagen,
    refresh: () => transact(async () => {}, ''),
    getState: () => ({ cart: clone(cart), products: clone(catalogue), mode: phase(), busy })
  };
  ready = refresh()
    .then(() => { render(); window.dispatchEvent(new CustomEvent('deen:cart-ready', { detail: { products: clone(catalogue), currency: cart.currency } })); })
    .catch(e => { error = e.message; stale = true; render(); });
  window.DeenCart.ready = ready;
  render();
})();
